
import { GenderEnum } from "./GenderEnum"
export function describeGenderEnum(e: GenderEnum): string{
    switch(e){
        case GenderEnum.Male:
            return "男";
        case GenderEnum.Female:
            return "女";
        default:
            throw new Error(`${e} is an invalid GenderEnum`);
    }
}
		